import axios from "axios";
import Cookies from "js-cookie";
import { FIRMFLOWURL } from "../url";

/**
 * Gets the due date summary for a given client.
 * It returns counts for: pastDue, next7Days (includes today), thereafter.
 * It may also return dueTodayCount as auxiliary metadata for next7Days.
 *
 * @param {Object} payload
 * @param {string} payload.clientId - Required
 * @param {string} [payload.departmentId] - Optional (use null/undefined or Guid.Empty if your backend expects it)
 * @param {string} [payload.employeeId] - Optional (use null/undefined or Guid.Empty if your backend expects it)
 */
export const getClientDueDateSummary = (payload) => {
    return new Promise(async (resolve) => {
        try {
            const token = Cookies.get("Bearer");

            const response = await axios.put(
                `${FIRMFLOWURL}api/Analytics/dueDateReport/services/summary`,
                {
                    clientId: payload.clientId,
                    departmentId: payload.departmentId,
                    employeeId: payload.employeeId,
                },
                {
                    headers: { Authorization: token },
                    params: { includeInactive: Boolean(payload.includeInactive) },
                }
            );

            resolve({ ...response, success: true });
        } catch (err) {
            console.log("error on getClientDueDateSummary", err);
            if (err.message.includes(401)) {
                Cookies.remove("Bearer");
                window.location.replace("/");
                return;
            }
            resolve({ success: false, message: err.message });
        }
    });
};
